
  import Vue from "vue";
  import { Component } from "vue-property-decorator";

  @Component
  export default class Rodape extends Vue {
    data() {
      return {
        dialogVaga2: false
      };
    }
  }
